import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { RequestManagementComponent } from './request-management.component';
import { RequestService } from '@fuse/services/request/request.service';
import { MatIconModule, MatButtonModule, MatTableModule, MatCheckboxModule, MatMenuModule, MatPaginatorModule, MatSortModule, MatToolbarModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatSnackBarModule, MatSelectModule } from '@angular/material';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RequestListComponent } from './request-list/request-list.component';
import { RequestFormDialogComponent } from './request-form/request-form.component';

const routes = [
    {
        path: 'request',
        component: RequestManagementComponent

    }
];

@NgModule({
    declarations: [
        RequestManagementComponent,
        RequestListComponent,
        RequestFormDialogComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSortModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatSnackBarModule,
        MatSelectModule,
        MatTooltipModule
    ],
    providers: [
        RequestService
    ],
    exports: [
        RequestManagementComponent
    ]
    ,
    entryComponents: [
        RequestFormDialogComponent
    ]
})

export class RequestManagementModule {
}
